import { Horizon } from "@/store/geo-test/types";

export const HORIZONS: Horizon[] = [
    {
        value: 1,
        label: 'газонефтяной, или ГНК',
        depth: null,
        checked: false,
        name: 'ГНК',
        lineWidth: 2,
        lineColor: 'red',
    },
    {
        value: 2,
        label: 'водонефтяной, или ВНК',
        depth: null,
        checked: false,
        name: 'ВНК',
        lineWidth: 2,
        lineColor: 'blue',
    },
];
export const values = HORIZONS.map(option => option.value);
